import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Grid from "@mui/material/Grid2";
import moment from "moment";

export interface ITableProps {
    dataToTable: any[],
    setdataToTable: any,
    filteredData: any[],
    filters: any[]
}


const SubSurfaceJobs = ({ dataToTable, setdataToTable, filteredData, filters }: ITableProps) => {

    const { subsurfaceJobs } = useSelector((state) => state.location);

    const [dataColumns, setDataColumns] = useState<GridColDef[]>([
        { field: 'programDate', headerName: 'Fecha de Programa', minWidth: 150, flex: 1 },
        { field: 'finishedDate', headerName: 'Fecha de culminacion', minWidth: 170, flex: 1 },
        { field: 'status', headerName: 'Estado programada', minWidth: 150, flex: 1 },
        { field: 'typeOfWork', headerName: 'Tipo de Trabajo', minWidth: 200, flex: 1 },
        { field: 'type_of_work_homologated', headerName: 'Tipo de trabajo homologado', minWidth: 200, flex: 1 },
        { field: 'userGenerated', headerName: 'generado Por', minWidth: 200, flex: 1 },
        { field: 'estimatedHours', headerName: 'Horas Estimadas', minWidth: 200, flex: 1 },
        { field: 'grossProduction', headerName: 'Produccion previa', minWidth: 200, flex: 1 },
        { field: 'targetProductionAfterWork', headerName: 'Produccion Esperada', minWidth: 200, flex: 1 },
        { field: 'description', headerName: 'comentarios', minWidth: 200, flex: 1 },
    ])

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {
        const datToTable: any[] = []

        let sortActivities: any[] = [...subsurfaceJobs].sort((a: any, b: any) => new Date(b.programDate).getTime() - new Date(a.programDate).getTime());

        for (const filter of filters) {
            const filterData = filteredData.find(f => f.name === filter.name);
            if (filterData) {
                if (filterData.action === 'greater') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                } else if (filterData.action === 'less') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                } else if (filterData.action === 'equal') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                } else if (filterData.action === 'different') {
                    sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                } else if (filterData.action === 'dissable') {
                    sortActivities = sortActivities || [];
                } else if (filterData.action === 'include' && filterData.value.length > 0) {
                    sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                } else if (filterData.action === 'equalAfter') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.programDate);
                        return locationDate.isSameOrAfter(filterData.value, 'day')
                    });
                } else if (filterData.action === 'equalBefore') {
                    sortActivities = sortActivities.filter((x) => {
                        const locationDate = moment(x.programDate)
                        return locationDate.isSameOrBefore(filterData.value, 'day')
                    });
                }
            }
        }

        for (const act of sortActivities) {
            const data:any = {
                id: act.id,
                samplingDate: act.samplingDate,
                receptionDate: act.receptionDate,
                freeWaterPercentage: act.freeWaterPercentage,
            }


            const dateField:string[]= ['programDate','finishedDate']

            for (const field of dateField) {
                if (act[field]) {
                    try {
                        data[field] = moment(act[field]).format('DD/MM/YYYY')
                    } catch (error) {
                        
                    }
                }
            }

            const doubleField:string[] = []

            for (const field of doubleField) {
                if (act[field]) {
                    try {
                        data[field] = parseFloat(act[field])
                    } catch (error) {
                        
                    }
                }
            }

            const stringField:string[] = ['status','typeOfWork','type_of_work_homologated','userGenerated','estimatedHours','grossProduction','targetProductionAfterWork','description']
            for (const field of stringField) {
                if (act[field]) {
                    try {
                        data[field] = act[field]
                    } catch (error) {
                    }
                }
            }

            datToTable.push(data)
        }

        setdataToTable(datToTable)

    }, [subsurfaceJobs, filteredData])


    return (
        <Grid className="table-container">
            <DataGrid
                rows={dataToTable}
                columns={dataColumns}
                initialState={{
                    pagination: { paginationModel }
                }}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "#316EBC",
                        color: "#fff",
                        fontWeight: "bold",
                    },
                }}
                getRowId={(row) => row.id}
            />
        </Grid>
    )
}

export default SubSurfaceJobs